module.exports = __webpack_public_path__ + "static/media/death_mode.b36eedd4.png";